import React from 'react';
import { clsx } from 'clsx';
import styles from './LoadingSpinner.module.css';

export type LoadingSpinnerProps = {
	/**
	 * Styles to apply over the loading container
	 */
	className?: string;

	/**
	 * Size of the loading, it is big by default
	 * @default big
	 */
	size?: 'small' | 'medium' | 'big' | 'extra-big';

	/**
	 * Variant of color to be shown, depending of this should have different color.
	 * @default light
	 */
	variant?: 'light' | 'dark';

	/**
	 * Text to show with the spinner
	 */
	children?: React.ReactNode;

	/**
	 * The orientation of the text to be shown, in the same line of the spinner (vertical) or as two rows.
	 * @default horizontal
	 */
	orientation?: 'horizontal' | 'vertical';
};

export function LoadingSpinner({
	children,
	orientation,
	variant = 'light',
	size = 'big',
	className
}: LoadingSpinnerProps) {
	return (
		<div className={clsx(styles.outerContainer, className)} role="progressbar">
			<div
				className={clsx(styles.innerContainer, {
					[styles.innerContainerVertical]: orientation === 'vertical',
					[styles.innerContainerSmall]: size === 'small',
					[styles.innerContainerMedium]: size === 'medium',
					[styles.innerContainerExtraBig]: size === 'extra-big'
				})}
			>
				<div className={styles.spinnerWrapper}>
					<div className={styles.spinnerContainer}>
						<div
							className={clsx(styles.spinnerCircle, styles.spinnerFirstCircle, {
								[styles.spinnerDark]: variant === 'dark'
							})}
						></div>
						<div className={clsx(styles.spinnerCircle, styles.spinnerSecondCircle)}></div>
					</div>
				</div>
				{children && <span className={styles.spinnerText}>{children}</span>}
			</div>
		</div>
	);
}
